export default {
    items: [
        // {
        //     name: 'Федеральные округа', //НСБ › Система › Справочник › Федеральные округа
        //     url: '/regions/',
        //     icon: 'icon-puzzle'
        // },
        {
            name: 'Города',
            url: '/tech/cities',
            icon: 'icon-puzzle',
        },
        {
            name: 'Объекты отдыха',
            url: '/tech/hotels',
            icon: 'icon-puzzle',
        },
        {
            name: 'Типы объектов',
            url: '/tech/htypes',
            icon: 'icon-puzzle',
        },
        // {
        //     name: 'Ответы', // Ответы на вопросы › Управление
        //     url: '/tech/faq',
        //     icon: 'icon-puzzle'
        // },
        // {
        //     name: 'Статьи', // дарт › Статьи › Управление
        //     url: '/tech/articles',
        //     icon: 'icon-puzzle'
        // },
        {
            name: 'Группы заболеваний', // НСБ › Система › Справочник › Заболевания
            url: '/tech/disease-categories',
            icon: 'icon-puzzle'
        },
        {
            name: 'Заболевания', // НСБ › Система › Справочник › Заболевания
            url: '/tech/diseases',
            icon: 'icon-puzzle'
        },
        {
            name: 'Инфраструктура о/о', // НСБ › Система › Объекты отдыха › Параметры
            url: '/tech/services',
            icon: 'icon-puzzle'
        },
        {
            name: 'Параметры номера', // НСБ › Система › Объекты отдыха › Параметры
            url: '/tech/room-features',
            icon: 'icon-puzzle'
        },
        // {
        //     name: 'Лечебные базы', // НСБ › Система › Объекты отдыха › Лечебные базы
        //     url: '/tech/cities',
        //     icon: 'icon-puzzle'
        // },
        // {
        //     name: 'Профили', // НСБ › Система › Объекты отдыха › Профили
        //     url: '/tech/cities',
        //     icon: 'icon-puzzle'
        // },
        // {
        //     name: 'Типы', // НСБ › Система › Объекты отдыха › Типы
        //     url: '/tech/cities',
        //     icon: 'icon-puzzle'
        // },
        // {
        //     name: 'Отчеты', // НСБ › Система › Технический отдел
        //     url: '/tech/cities',
        //     icon: 'icon-puzzle'
        // },
        // {
        //     name: 'Профкурорт', // НСБ › Система › Внешние системы › Профкурорт › Объекты отдыха
        //     url: '/tech/cities',
        //     icon: 'icon-puzzle'
        // },
        {
            name: 'Формы',
            url: '/tech/webform',
            icon: 'icon-puzzle'
        },

    ]
}
